import { CommonPage } from "./CommonPage";
import type { ClaimInfoHeader } from "./ClaimInfoHeader";
import type { SessionExpiry } from "../session/SessionExpiry";
import type { PageHeader } from "./PageHeader";
import type { PageNavigation } from "./PageNavigation";
import { NullClaimInfoHeader } from "./NullClaimInfoHeader";
import { NullSessionExpiry } from "../session/NullSessionExpiry";
import { NullPageHeader } from "./NullPageHeader";
import { NullPageNavigation } from "./NullPageNavigation";
import { ClaimTabs } from "./ClaimTabs";
import { NullClaimTabs } from "./NullClaimTabs";

export class NullCommonPage implements CommonPage {
    readonly sessionExpiry: SessionExpiry = new NullSessionExpiry;
    readonly claimInfoHeader: ClaimInfoHeader = new NullClaimInfoHeader();
    readonly pageHeader: PageHeader = new NullPageHeader();
    readonly pageNavigation: PageNavigation = new NullPageNavigation();
    readonly claimTabs: ClaimTabs = new NullClaimTabs();
}
